import { SelectItem } from '@diamond/shared/types';
import { Dropdown } from '@diamond/shared/ui';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

interface ItemSortByProps {
  sortsData: SelectItem[];
}

type FormProps = {
  sortby: string;
};

export const ItemSortBy: FC<ItemSortByProps> = ({ sortsData }) => {
  const { pathname, query, push } = useRouter();
  const { register, handleSubmit } = useForm({
    defaultValues: {
      sortby: (query['sortby'] as string) || '',
    },
    values: {
      sortby: (query['sortby'] as string) || '',
    },
  });

  const submitHandler: SubmitHandler<FormProps> = ({
    sortby,
  }: {
    sortby: string | string[];
  }) => {
    const url = { pathname, query: { ...query, sortby, page: 1 } };
    push(url, undefined, { shallow: true });
  };

  return (
    <form
      onSubmit={handleSubmit(submitHandler)}
      onChange={handleSubmit(submitHandler)}
    >
      <Dropdown
        name="sortby"
        placeholder="Semua"
        size="md"
        items={sortsData}
        register={register}
      />
    </form>
  );
};
